// extracted by mini-css-extract-plugin
export var activeFilterButton = "_jd-c";
export var backButton = "_jd-4";
export var backIcon = "_jd-5";
export var chevronShortcut = "_jd-6";
export var container = "_jd-1";
export var editor = "_jd-8";
export var editorWrapper = "_jd-7";
export var prefix = "_jd-2";
export var searchIcon = "_jd-3";
export var suffix = "_jd-9";
export var suffixContent = "_jd-a";
export var suffixText = "_jd-b";
export var wrapper = "_jd-0";